import React from "react";
import {downloadFile} from "../../../utils/download.utils";
import {exportService} from "../../../services/exportService";
import {Button} from "antd";
import PropTypes from "prop-types";
import CloudDownloadOutlined from "@ant-design/icons/lib/icons/CloudDownloadOutlined";

export const DownloadColumn = ({record}) => {

    function handleDownload(exportId, exportSnapshotId) {

        exportService.download(exportId, exportSnapshotId).then(response => {
            const disposition = response.headers['content-disposition'];
            let filename = 'download.xlsx'; // default
            if (disposition && disposition.includes('filename=')) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    filename = match[1].replace(/['"]/g, ''); // remove quotes
                }
            }
            downloadFile(response.data, filename, "octet/stream");
        })
    }

    if (record.state === 'DONE') {
        return <Button onClick={() => handleDownload(record.exportId, record.id)}
                       title={"Download exported data"}
                       type={"text"}
                       icon={<CloudDownloadOutlined />}/>
    } else if (record.state === 'STARTED') {
        return <>Preparing...</>
    } else if (record.state === 'FAILED') {
        return <></>
    } else {
        return 'Invalid state'
    }

}

DownloadColumn.propTypes = {
    record: PropTypes.object.isRequired
}